
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import CouponContent from "../components/coupon-discount-content.vue";
import dayjs from "dayjs";
import { InjectFunction } from "@common/src/utils/decorator";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";
import t from "@common/src/i18n/t";
const marketing = namespace("marketing");
const base = namespace("base");
const coupon = namespace("coupon");
@InjectFunction("dayjs", "permitApp", "appCode")
@Component({
  components: {
    CouponContent,
    StandardFlag
  }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("setting.choose-payment-method"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class DiscountCoupon extends Vue {
  @marketing.Action queryCardTemplateList;
  @base.Action getDictionaryList;
  @coupon.Action queryList;
  @coupon.Action disable;
  @coupon.Action couponSyncToStore;
  dayjs = dayjs;
  activityStatusList: any = [];
  couponTypeList: any = [];
  hoverRow = undefined;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  searchForm = {
    activityName: "",
    activityStatus: "",
    couponType: ""
  };
  cardTemplateList: any[] = [];
  //计算属性
  get searchList() {
    return [
      {
        label: "marketing.discount-coupon-name",
        type: "input",
        value: "",
        prop: "activityName"
      },
      {
        label: "marketing.coupon-type",
        type: "select",
        value: "",
        selectList: this.couponTypeList,
        prop: "couponType"
      },
      {
        label: "finance.state",
        type: "select",
        value: "",
        selectList: this.activityStatusList,
        prop: "activityStatus"
      }
    ];
  }
  created() {
    this.init();
  }
  getVisible() {
    return true;
  }

  statusCodeMap: any = {
    speedbiz: "coupon_activity_status",
    "speedbiz-operation": "op_coupon_activity_status"
  };
  async init() {
    this.loadListData();
    this.getDictionaryList("coupon_type").then(data => {
      this.couponTypeList = data;
    });

    this.getDictionaryList(this.statusCodeMap[this.appCode]).then(data => {
      this.activityStatusList = data;
    });
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  handleComfirmCommand(command) {
    switch (command) {
      case "edit":
        this.$router.push(`/marketing/created-coupon/${this.hoverRow.activityCode}`);
        break;
      case "copy":
        this.$router.push(`/marketing/created-coupon/add?copyCode=${this.hoverRow.activityCode}`);
        break;
      default:
        this.confirmUpdateStatus();
      // 完成入库
    }
  }
  onSureDisable(row) {
    this.disable({ activityCode: row.activityCode }).then(res => {
      if (!res.data) {
        this.$message.success(t("setting.disable-success"));
        this.loadListData();
      }
    });
  }
  confirmUpdateStatus() {
    console.log("gg");
  }
  handleSetCurrentRow(visible, row) {
    this.hoverRow = row;
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryList({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.cardTemplateList = data.data.list;
      return data;
    });
  }
  handleView(row) {
    this.$router.push(`/marketing/look-coupon/${row.activityCode}`);
  }
  createdCoupon() {
    this.$router.push({
      name: "marketingCreatedCouponAdd"
    });
  }
  handleSyncStore(row) {
    this.couponSyncToStore({
      activityCode: row.activityCode
    }).then(() => {
      this.$message.success(t("v270.coupons-have-been-synchronized-to-the-store"));
      this.loadListData();
    });
  }
}
